import { mentorConstants } from "../../_constants";
import axiosInstance from "../../../_helpers/axiosInstance";
import config from "../../../_config/config";
import {
  showSuccessMessage,
  showWarningMessage,
} from "../../../_uiComponents/ShowMessageSnack";

// create mentor
export const create_mentor_action = (data) => async (dispatch) => {
  dispatch({
    type: mentorConstants.CREATE_MENTOR_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.put(config.auth.onBoard, data);
    if (response.status) {
      const user = JSON.parse(localStorage.getItem("jigsawUser"));
      user.user.user_meta_info["phone"] = data.phone;
      localStorage.setItem("jigsawUser", JSON.stringify(user));
      dispatch({
        type: mentorConstants.CREATE_MENTOR_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: mentorConstants.CREATE_MENTOR_ACTION_FAILURE,
      payload: e.msg,
    });
    showWarningMessage(e?.msg);

    return e;
  }
};

//get mentor profile
export const get_mentor_profile_data_action = () => async (dispatch) => {
  dispatch({
    type: mentorConstants.GET_MENTOR_PROFILE_DATA_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.get(config.mentor.mentorProfile);
    if (response.status) {
      dispatch({
        type: mentorConstants.GET_MENTOR_PROFILE_DATA_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: mentorConstants.GET_MENTOR_PROFILE_DATA_ACTION_FAILURE,
      payload: e.msg,
    });
    showWarningMessage(e?.msg);

    return e;
  }
};

// update mentor profile
export const update_mentor_profile_action = (data) => async (dispatch) => {
  dispatch({
    type: mentorConstants.UPDATE_MENTOR_PROFILE_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.put(config.mentor.mentorProfile, data);
    if (response.status) {
      showSuccessMessage("Successfully updated.");
      dispatch({
        type: mentorConstants.UPDATE_MENTOR_PROFILE_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: mentorConstants.UPDATE_MENTOR_PROFILE_ACTION_FAILURE,
      payload: e.msg,
    });
    showWarningMessage(e?.msg);

    return e;
  }
};

// get all educational data
export const get_mentor_all_educational_data_action =
  () => async (dispatch) => {
    dispatch({
      type: mentorConstants.GET_MENTOR_ALL_EDUCATIONAL_DATA_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.get(
        config.mentor.getMentorAllEducationData
      );
      if (response.status) {
        dispatch({
          type: mentorConstants.GET_MENTOR_ALL_EDUCATIONAL_DATA_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: mentorConstants.GET_MENTOR_ALL_EDUCATIONAL_DATA_ACTION_FAILURE,
        payload: e.msg,
      });
      return e;
    }
  };

// get education by id
export const get_mentor_education_by_id_data_action =
  (id) => async (dispatch) => {
    dispatch({
      type: mentorConstants.GET_MENTOR_EDUCATION_BY_ID_DATA_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.get(
        config.mentor.getMentorEducationByIdData.replace(":id", id)
      );
      if (response.status) {
        dispatch({
          type: mentorConstants.GET_MENTOR_EDUCATION_BY_ID_DATA_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: mentorConstants.GET_MENTOR_EDUCATION_BY_ID_DATA_ACTION_FAILURE,
        payload: e.msg,
      });
      return e;
    }
  };

//update education by id
export const update_mentor_education_by_id_data_action =
  (data, id) => async (dispatch) => {
    dispatch({
      type: mentorConstants.UPDATE_MENTOR_EDUCATION_BY_ID_DATA_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.put(
        config.mentor.getMentorEducationByIdData.replace(":id", id),
        data
      );
      if (response.status) {
        dispatch({
          type: mentorConstants.UPDATE_MENTOR_EDUCATION_BY_ID_DATA_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: mentorConstants.UPDATE_MENTOR_EDUCATION_BY_ID_DATA_ACTION_FAILURE,
        payload: e.msg,
      });
    }
  };

//create new education
export const create_mentor_education_data_action =
  (data) => async (dispatch) => {
    dispatch({
      type: mentorConstants.CREATE_MENTOR_EDUCATION_DATA_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.post(
        config.mentor.createMentorEducation,
        data
      );
      if (response.status) {
        dispatch({
          type: mentorConstants.CREATE_MENTOR_EDUCATION_DATA_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: mentorConstants.CREATE_MENTOR_EDUCATION_DATA_ACTION_FAILURE,
        payload: e.msg,
      });
    }
  };

//get all professional data
export const get_mentor_all_professional_data_action =
  () => async (dispatch) => {
    dispatch({
      type: mentorConstants.GET_MENTOR_ALL_PROFESSIONAL_DATA_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.get(
        config.mentor.getMentorAllProfessionalData
      );
      if (response.status) {
        dispatch({
          type: mentorConstants.GET_MENTOR_ALL_PROFESSIONAL_DATA_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: mentorConstants.GET_MENTOR_ALL_PROFESSIONAL_DATA_ACTION_FAILURE,
        payload: e.msg,
      });
      return e;
    }
  };

//get profession by id
export const get_mentor_profession_by_id_data_action =
  (id) => async (dispatch) => {
    dispatch({
      type: mentorConstants.GET_MENTOR_PROFESSION_BY_ID_DATA_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.get(
        config.mentor.getMentorExperienceByIdData.replace(":id", id)
      );
      if (response.status) {
        dispatch({
          type: mentorConstants.GET_MENTOR_PROFESSION_BY_ID_DATA_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: mentorConstants.GET_MENTOR_PROFESSION_BY_ID_DATA_ACTION_FAILURE,
        payload: e.msg,
      });
      return e;
    }
  };

//update profession by id
export const update_mentor_profession_by_id_data_action =
  (data, id) => async (dispatch) => {
    dispatch({
      type: mentorConstants.UPDATE_MENTOR_PROFESSION_BY_ID_DATA_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.put(
        config.mentor.getMentorExperienceByIdData.replace(":id", id),
        data
      );
      if (response.status) {
        dispatch({
          type: mentorConstants.UPDATE_MENTOR_PROFESSION_BY_ID_DATA_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: mentorConstants.UPDATE_MENTOR_PROFESSION_BY_ID_DATA_ACTION_FAILURE,
        payload: e.msg,
      });
    }
  };

//create new profession data
export const create_mentor_profession_data_action =
  (data) => async (dispatch) => {
    dispatch({
      type: mentorConstants.CREATE_MENTOR_PROFESSION_DATA_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.post(
        config.mentor.createMentorExperience,
        data
      );
      if (response.status) {
        dispatch({
          type: mentorConstants.CREATE_MENTOR_PROFESSION_DATA_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: mentorConstants.CREATE_MENTOR_PROFESSION_DATA_ACTION_FAILURE,
        payload: e.msg,
      });
    }
  };

//get all skills data
export const get_mentor_all_skills_data_action = () => async (dispatch) => {
  dispatch({
    type: mentorConstants.GET_MENTOR_ALL_SKILLS_DATA_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.get(
      config.mentor.getMentorAllSkillsData
    );
    if (response.status) {
      dispatch({
        type: mentorConstants.GET_MENTOR_ALL_SKILLS_DATA_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: mentorConstants.GET_MENTOR_ALL_SKILLS_DATA_ACTION_FAILURE,
      payload: e.msg,
    });
    showWarningMessage(e?.msg);

    return e;
  }
};

//update profession by id
export const create_mentor_skills_data_action = (data) => async (dispatch) => {
  dispatch({
    type: mentorConstants.CREATE_MENTOR_SKILLS_DATA_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.post(
      config.mentor.createMentorSkill,
      data
    );
    if (response.status) {
      dispatch({
        type: mentorConstants.CREATE_MENTOR_SKILLS_DATA_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: mentorConstants.CREATE_MENTOR_SKILLS_DATA_ACTION_FAILURE,
      payload: e.msg,
    });
  }
};

//create new profession data
export const delete_mentor_skill_by_id_data_action =
  (id) => async (dispatch) => {
    dispatch({
      type: mentorConstants.DELETE_MENTOR_SKILL_BY_ID_DATA_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.delete(
        config.mentor.deleteMentorSkillById.replace(":id", id)
      );
      if (response.status) {
        dispatch({
          type: mentorConstants.DELETE_MENTOR_SKILL_BY_ID_DATA_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: mentorConstants.DELETE_MENTOR_SKILL_BY_ID_DATA_ACTION_FAILURE,
        payload: e.msg,
      });
    }
  };

//create new profession data
export const update_mentor_skill_by_id_data_action =
  (id, data) => async (dispatch) => {
    dispatch({
      type: mentorConstants.UPDATE_MENTOR_SKILL_BY_ID_DATA_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.put(
        config.mentor.deleteMentorSkillById.replace(":id", id),
        data
      );
      if (response.status) {
        dispatch({
          type: mentorConstants.UPDATE_MENTOR_SKILL_BY_ID_DATA_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: mentorConstants.UPDATE_MENTOR_SKILL_BY_ID_DATA_ACTION_FAILURE,
        payload: e.msg,
      });
    }
  };

//delete education
export const delete_mentor_education_by_id_data_action =
  (id) => async (dispatch) => {
    dispatch({
      type: mentorConstants.DELETE_MENTOR_EDUCATION_BY_ID_DATA_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.delete(
        config.mentor.deleteMentorEducationByIdData.replace(":id", id)
      );
      if (response.status) {
        dispatch({
          type: mentorConstants.DELETE_MENTOR_EDUCATION_BY_ID_DATA_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: mentorConstants.DELETE_MENTOR_EDUCATION_BY_ID_DATA_ACTION_FAILURE,
        payload: e.msg,
      });
    }
  };

//deletes experience
export const delete_mentor_profession_by_id_data_action =
  (id) => async (dispatch) => {
    dispatch({
      type: mentorConstants.DELETE_MENTOR_PROFESSION_BY_ID_DATA_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.delete(
        config.mentor.deleteMentorExperienceByIdData.replace(":id", id)
      );
      if (response.status) {
        dispatch({
          type: mentorConstants.DELETE_MENTOR_PROFESSION_BY_ID_DATA_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: mentorConstants.DELETE_MENTOR_PROFESSION_BY_ID_DATA_ACTION_FAILURE,
        payload: e.msg,
      });
    }
  };

//get all dashboard data
export const get_mentor_dashboard_data_action = () => async (dispatch) => {
  dispatch({
    type: mentorConstants.GET_MENTOR_DASHBOARD_DETAILS_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.get(config.mentor.getMentorDashboard);
    if (response.status) {
      dispatch({
        type: mentorConstants.GET_MENTOR_DASHBOARD_DETAILS_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: mentorConstants.GET_MENTOR_DASHBOARD_DETAILS_ACTION_FAILURE,
      payload: e.msg,
    });
    showWarningMessage(e?.msg);

    return e;
  }
};

// /get all dashbaoard data
export const get_mentor_kanbanboard_data_action =
  (id, stage) => async (dispatch) => {
    dispatch({
      type: mentorConstants.GET_MENTOR_KANBANBOARD_DETAILS_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.get(
        config.mentor.getMentorKanbanboard
          .replace(":id", id)
          .replace(":stage", stage)
      );

      if (response.status) {
        dispatch({
          type: mentorConstants.GET_MENTOR_KANBANBOARD_DETAILS_ACTION_SUCCESS,
          payload: response.data,
          status: stage,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: mentorConstants.GET_MENTOR_KANBANBOARD_DETAILS_ACTION_FAILURE,
        payload: e.msg,
      });
      return e;
    }
  };

//get mentor profile
export const view_mentor_profile_info_action = (id) => async (dispatch) => {
  dispatch({
    type: mentorConstants.VIEW_MENTOR_PROFILE_DATA_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.get(
      config.mentor.viewMentorProfile.replace(":id", id)
    );
    if (response.status) {
      dispatch({
        type: mentorConstants.VIEW_MENTOR_PROFILE_DATA_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: mentorConstants.VIEW_MENTOR_PROFILE_DATA_ACTION_FAILURE,
      payload: e.msg,
    });
    showWarningMessage(e?.msg);

    return e;
  }
};

//get all portfolio urls
export const get_mentor_all_portfolio_data_action = () => async (dispatch) => {
  dispatch({
    type: mentorConstants.GET_MENTOR_ALL_PORTFOLIO_DATA_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.get(
      config.mentor.getMentorAllPortfolioData
    );
    if (response.status) {
      dispatch({
        type: mentorConstants.GET_MENTOR_ALL_PORTFOLIO_DATA_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: mentorConstants.GET_MENTOR_ALL_PORTFOLIO_DATA_ACTION_FAILURE,
      payload: e.msg,
    });
    showWarningMessage(e?.msg);

    return e;
  }
};

//get portfolio url by id
export const get_mentor_portfolio_by_id_data_action =
  (id) => async (dispatch) => {
    dispatch({
      type: mentorConstants.GET_MENTOR_PORTFOLIO_BY_ID_DATA_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.get(
        config.mentor.getMentorPortfolioByIdData.replace(":id", id)
      );
      if (response.status) {
        dispatch({
          type: mentorConstants.GET_MENTOR_PORTFOLIO_BY_ID_DATA_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: mentorConstants.GET_MENTOR_PORTFOLIO_BY_ID_DATA_ACTION_FAILURE,
        payload: e.msg,
      });
      showWarningMessage(e?.msg);

      return e;
    }
  };

//update portfolio url by id
export const update_mentor_portfolio_by_id_data_action =
  (data, id) => async (dispatch) => {
    dispatch({
      type: mentorConstants.UPDATE_MENTOR_PORTFOLIO_BY_ID_DATA_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.put(
        config.mentor.updateMentorPortfolio.replace(":id", id),
        data
      );
      if (response.status) {
        dispatch({
          type: mentorConstants.UPDATE_MENTOR_PORTFOLIO_BY_ID_DATA_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: mentorConstants.UPDATE_MENTOR_PORTFOLIO_BY_ID_DATA_ACTION_FAILURE,
        payload: e.msg,
      });
    }
  };

//create new portfolio url
export const create_mentor_portfolio_data_action =
  (data) => async (dispatch) => {
    dispatch({
      type: mentorConstants.CREATE_MENTOR_PORTFOLIO_DATA_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.post(
        config.mentor.createMentorPortfolio,
        data
      );
      if (response.status) {
        dispatch({
          type: mentorConstants.CREATE_MENTOR_PORTFOLIO_DATA_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: mentorConstants.CREATE_MENTOR_PORTFOLIO_DATA_ACTION_FAILURE,
        payload: e.msg,
      });
      showWarningMessage(e.msg);
    }
  };

//deletes portfolio url
export const delete_mentor_portfolio_by_id_data_action =
  (id) => async (dispatch) => {
    dispatch({
      type: mentorConstants.DELETE_MENTOR_PORTFOLIO_BY_ID_DATA_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.delete(
        config.mentor.deleteMentorPortfolioByIdData.replace(":id", id)
      );
      if (response.status) {
        dispatch({
          type: mentorConstants.DELETE_MENTOR_PORTFOLIO_BY_ID_DATA_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: mentorConstants.DELETE_MENTOR_PORTFOLIO_BY_ID_DATA_ACTION_FAILURE,
        payload: e.msg,
      });
    }
  };

// get assigned candiates list
export const get_assigned_candidates_kanban_action =
  (id) => async (dispatch) => {
    dispatch({
      type: mentorConstants.GET_ASSIGNED_CANDIDATES_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.get(
        `${config.common.assignedCandidatList}${id}/`
      );
      if (response.status) {
        dispatch({
          type: mentorConstants.GET_ASSIGNED_CANDIDATES_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: mentorConstants.GET_ASSIGNED_CANDIDATES_ACTION_FAILURE,
        payload: e?.msg,
      });
      showWarningMessage(e?.msg);
    }
  };


// get invited candidates list
export const get_invited_candidates_kanban_action =
  (id) => async (dispatch) => {
    dispatch({
      type: mentorConstants.GET_INVITED_CANDIDATES_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.get(
        `${config.common.invitedCandidatList}${id}/`
      );
      if (response.status) {
        dispatch({
          type: mentorConstants.GET_INVITED_CANDIDATES_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: mentorConstants.GET_INVITED_CANDIDATES_ACTION_FAILURE,
        payload: e?.msg,
      });
      showWarningMessage(e?.msg);
    }
  };

